export function formatItemData(data) {
    const {
        type,
        name,
        expirationType,
        expirationDays,
        expirationDate,
        productionDate,
        purchaseDate,
        model,
        purchasePlace,
        cost,
        description,
        multiple,
        amount,
        serialNumber,
        files,
        oldFiles,
    } = data;

    return {
        quantitySwitcher: multiple ? 1 : 0,
        quantity: amount,

        name,
        model,

        guid: serialNumber,

        description,
        type_uniform_id: type,
        validityType: expirationType === "days" ? 0 : 1,
        exp_days: expirationDays,
        exp_date: expirationDate,
        manuf_date: productionDate,
        purch_date: purchaseDate,
        purch_place: purchasePlace,
        cost,
        files,
        oldFiles,
    };
}
